<script>
export default {
  props: {
    photo: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {};
  },
};
</script>

<template>
  <div @click.stop="$emit('view-photo', photo)">
    <img class="exercise-photo" :src="photo" />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.exercise-photo {
  cursor: pointer;
  height: 100%;
  width: 100%;
}
</style>
